import {
  Injectable
} from '@angular/core';
import {
  Observable
,
  BehaviorSubject
,
  Subscription
} from 'rxjs';
import {
  ApiService
} from '../services/api';
import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';
import * as moment from 'moment';

@Injectable()
export class CommissionsService extends BehaviorSubject<GridDataResult> {
  private subscription: Subscription;
  commissionsObserver: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);

  constructor(private api: ApiService) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  public getCommissions() {
    const params = new HttpParams().set('start', moment().subtract(90, 'days').toISOString());

    this.api.get<GridDataResult>('/commissions', params)
      .subscribe(result => {
        super.next(result);
      });
  }

  public getList(page: number, limit: number, start: Date, end: Date, individual:boolean, all:boolean, search?: string) {
    const params = new HttpParams()
    .set('page', page.toLocaleString())
    .set('limit', limit.toString())
      .set('start', start.toISOString())
      .set('end', end.toISOString())
      .set('mode', individual ? (all ? 'individual' : 'user') : 'organizational')
    .set('search', search);

    this.subscription = this.api.get<GridDataResult>('/commission', params)
      .subscribe(result => {
        super.next(result);
      });
  }
}
